import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { getCollection } from '@adornis/baseql/server/collections.js';

@Entity()
export class BadcontactEntity extends MongoEntity {
  static override _class = 'BadcontactEntity';
  static override _collectionName = 'Badcontact';

  @Field(() => String) odooContactID: Maybe<string>;
  @Field(() => String) displayName: Maybe<string>;
  @Field(() => String) email: Maybe<string>;
  @Field(() => String) badContactCategory: Maybe<string>;
  @Field(() => Int) ticketCount: Maybe<number>;
  @Field(() => Date) createdDateOdoo: Maybe<Date>;
  @Field(() => Boolean) isCheckedBySupport: Maybe<boolean>;
  @Field(() => Boolean) isSanitized: Maybe<boolean>;
  @Field(() => Date) createdAt: Maybe<Date>;

  static override async beforeCreate(entity: BadcontactEntity) {
    await super.beforeCreate(entity);
    entity.createdAt = new Date();
  }
}

export async function getAllOdooContactIdsAsNumber(): Promise<number[]> {
  const collection = await getCollection<BadcontactEntity>(BadcontactEntity._class);
  const contacts = await collection.find({}).toArray();
  return contacts.map(contact => parseInt(contact.odooContactID)).filter(id => !isNaN(id));
}

export async function deleteAllBadContacts(): Promise<void> {
  const collection = await getCollection<BadcontactEntity>(BadcontactEntity._class);
  const contacts = await collection.find({}).toArray();
  for (const contact of contacts) {
    await collection.deleteOne({ _id: contact._id });
  }
  return;
}

export async function fetchAllBadContacts() {
  const collection = await getCollection<BadcontactEntity>(BadcontactEntity._class);
  const contacts = await collection.find({}).toArray();
  return contacts.map(contact => new BadcontactEntity(contact));
}
